(function () {
  "use strict";

  var landing = document.querySelector("[data-cl-landing]");
  if (!landing) return;

  /* Scroll-triggered reveal */
  var revealTargets = landing.querySelectorAll("[data-cl-reveal]");
  if ("IntersectionObserver" in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: "0px 0px -10% 0px" }
    );

    revealTargets.forEach(function (el) {
      var delay = el.getAttribute("data-cl-reveal-delay");
      if (delay) el.style.setProperty("--cl-reveal-delay", delay);
      observer.observe(el);
    });
  } else {
    revealTargets.forEach(function (el) {
      el.classList.add("is-visible");
    });
  }

  /* Hero zoom-out on scroll + header state toggle */
  var hero = landing.querySelector("[data-cl-hero]");
  var heroImage = hero ? hero.querySelector(".cl-hero__image") : null;
  var illustrationImg = hero ? hero.querySelector("[data-cl-illustration-scroll] .cl-hero__illustration-img") : null;
  var illustrationMaxProgress = 0;
  var ticking = false;

  /* Panel image scroll effects (rotate / slide) — continuous and reversible:
     recalculated from the element's live position every frame, so scrolling
     back up undoes it, unlike the hero illustration's one-way zoom. */
  var panelEffectEls = Array.prototype.slice.call(landing.querySelectorAll("[data-cl-panel-effect]")).filter(function (el) {
    return el.getAttribute("data-cl-panel-effect");
  });

  function updatePanelEffects() {
    var viewportH = window.innerHeight;
    panelEffectEls.forEach(function (el) {
      var effect = el.getAttribute("data-cl-panel-effect");
      var img = el.querySelector(".cl-panel__image");
      if (!img) return;
      var rect = el.getBoundingClientRect();
      /* 0 when element enters the bottom of the viewport, 1 when it exits the top */
      var progress = (viewportH - rect.top) / (viewportH + rect.height);
      progress = Math.min(Math.max(progress, 0), 1);
      var centered = (progress - 0.5) * 2; /* -1 -> 1, 0 at viewport center */
      /* Movimiento vertical + escala suave */
var translateY = centered * -70;
var scale = 1 + centered * 0.05;

img.style.setProperty(
  "--cl-panel-translate-y",
  translateY.toFixed(1) + "px"
);

img.style.setProperty(
  "--cl-panel-scale",
  scale.toFixed(3)
);
      if (effect === "rotate-cw" || effect === "rotate-ccw") {
        var angle = centered * 25 * (effect === "rotate-cw" ? 1 : -1);
        img.style.setProperty("--cl-panel-rotate", angle.toFixed(2) + "deg");
      } else if (effect === "slide-left" || effect === "slide-right") {
        var offset = centered * 60 * (effect === "slide-left" ? -1 : 1);
        img.style.setProperty("--cl-panel-translate-x", offset.toFixed(1) + "px");
      }
    });
  }
/* Panel image scroll motion — continuous and reversible */
var panels = landing.querySelectorAll(".cl-panel");

function updatePanelMotion() {
  var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

  panels.forEach(function (panel) {
    var rect = panel.getBoundingClientRect();

    /*
      0 = panel todavía por debajo
      0.5 = panel aproximadamente centrado
      1 = panel saliendo por arriba
    */
    var progress =
      (viewportHeight - rect.top) /
      (viewportHeight + rect.height);

    progress = Math.min(Math.max(progress, 0), 1);

    panel.style.setProperty(
      "--cl-panel-scroll",
      progress.toFixed(3)
    );
  });
}
  function updateOnScroll() {
    var scrollY = window.scrollY || window.pageYOffset;

    if (heroImage) {
      var heroHeight = hero.offsetHeight || 1;
      var progress = Math.min(Math.max(scrollY / heroHeight, 0), 1);
      hero.style.setProperty("--cl-scroll", progress.toFixed(3));

      if (illustrationImg) {
        /* Monotonic: only grows on scroll down, never reverses on scroll up (matches the original) */
        illustrationMaxProgress = Math.max(illustrationMaxProgress, progress);
        var scale = 1 + illustrationMaxProgress * 0.4;
        var translateY = illustrationMaxProgress * -150;
        illustrationImg.style.setProperty("--cl-illustration-scale", scale.toFixed(3));
        illustrationImg.style.setProperty("--cl-illustration-ty", translateY.toFixed(1) + "px");
      }
    }

    updatePanelEffects();

    if (scrollY > (hero ? hero.offsetHeight * 0.8 : 80)) {
      document.body.classList.add("cl-scrolled");
    } else {
      document.body.classList.remove("cl-scrolled");
    }
updatePanelMotion();
    ticking = false;
  }

  window.addEventListener(
    "scroll",
    function () {
      if (!ticking) {
        window.requestAnimationFrame(updateOnScroll);
        ticking = true;
      }
    },
    { passive: true }
  );

  updateOnScroll();

  /* Carousel (image + caption slides, prev/next arrows + dots) */
  var carousels = landing.querySelectorAll("[data-cl-carousel]");
  carousels.forEach(function (carousel) {
    var track = carousel.querySelector("[data-cl-carousel-track]");
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    if (!track || slides.length < 2) return;

    var dotsWrap = carousel.querySelector("[data-cl-carousel-dots]");
    var index = 0;

    slides.forEach(function (slide, i) {
      var dot = document.createElement("button");
      dot.type = "button";
      dot.className = "cl-carousel__dot";
      dot.setAttribute("aria-label", "Ir a la diapositiva " + (i + 1));
      dot.addEventListener("click", function () {
        goTo(i);
      });
      dotsWrap.appendChild(dot);
    });
    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll(".cl-carousel__dot"));

    function update() {
      track.style.transform = "translateX(-" + index * 100 + "%)";
      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === index);
      });
    }

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      update();
    }

    var prevBtn = carousel.querySelector("[data-cl-carousel-prev]");
    var nextBtn = carousel.querySelector("[data-cl-carousel-next]");
    if (prevBtn) prevBtn.addEventListener("click", function () { goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { goTo(index + 1); });

    update();
  });
})();
